import dynamic from "next/dynamic";

import { useContext } from "react";
import { useAuth0V2 } from "@stadium/services/auth0";

import UnAuthenticatedButton from "@components/swagmagic/profile-dropdown/unauthenticated-button";
import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";
import { StadiumSharedConfigWrapper } from "@stadium/shared/global-config";

import { getStadiumSharedConfig } from "@helpers/config";

const WebProfileDropdown = dynamic(
  () => import("@components/store/navigation/ProfileDropdown/web"),
);

const ResponsiveProfileDropdown = dynamic(
  () =>
    import("@components/store/navigation/ProfileDropdown/responsive", {
      ssr: false,
    }),
);

const ProfileDropdown = ({ renderResponsiveView = true }) => {
  const { isAuthenticated } = useAuth0V2();
  const currentDeviceType = useContext(CurrentDeviceContext);
  const { isDesktopDevice } = currentDeviceType;

  const renderProfileDropdown = () => {
    if (isDesktopDevice) {
      return <WebProfileDropdown />;
    }
    if (renderResponsiveView) {
      return <ResponsiveProfileDropdown />;
    }
    return null;
  };

  if (!isAuthenticated) {
    return renderResponsiveView || isDesktopDevice ? <UnAuthenticatedButton /> : null;
  }

  return (
    <StadiumSharedConfigWrapper value={getStadiumSharedConfig}>
      {renderProfileDropdown()}
    </StadiumSharedConfigWrapper>
  );
};

export default ProfileDropdown;
